module.exports = __webpack_public_path__ + "img/teams-big-folder.6ae4861e.svg";